var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendVerificationCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.77 64.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#022752;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-send",
    "data-name": "Icon ionic-ios-send",
    className: "cls-1",
    d: "M62.74.14.8,27.13A1.43,1.43,0,0,0,.14,29a1.38,1.38,0,0,0,.71.68l16.77,9.47a2.7,2.7,0,0,0,3.09-.3l33-28.48c.22-.19.74-.54.94-.34s-.11.72-.3.95L25.79,43.2a2.68,2.68,0,0,0-.27,3.22L36.47,64a1.43,1.43,0,0,0,1.91.63,1.37,1.37,0,0,0,.65-.67L64.65,2A1.41,1.41,0,0,0,63.92.12,1.39,1.39,0,0,0,62.74.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendVerificationCode);
export default __webpack_public_path__ + "static/media/Resend Verification Code.925dd61253b8608e6774e961535540b1.svg";
export { ForwardRef as ReactComponent };